export const BUILD_VERSION = '1787134378047';
